import { init_as_module } from "./posthog-core";
export { AuthingInsight as AuthingInsight } from "./posthog-core";
export * from "./types";
export const authingInsight = init_as_module();
export default authingInsight;
